import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import Header from "../../../layout/mypage/Header";
import Footer from "../../../layout/mypage/Footer";
import {
  validateRequired,
  validateHalfAlphaNum,
} from "../../../../utils/validate";
import { MSG } from "../../../../utils/adminMessages";
import { useAuth } from "../../../../contexts/AuthContext";
import MypageTextField from "../../../ui/MypageTextField";
import ScreenColorSetting, {
  getDefaultScreenColor,
} from "../../../layout/mypage/ScreenColorSetting";
import { MYPAGE_HTML_TITLE } from "../../../../utils/config";

// マイページログイン画面
const Login = () => {
  // 画面背景色 color-standard or color-black or color-blue
  const [screenColor, setScreenColor] = useState(getDefaultScreenColor());

  // 認証用
  const { mypageLogin, isAuthenticated } = useAuth();

  // URLパラメータ
  let isSessionExp = false;
  const search = useLocation().search;
  const query = new URLSearchParams(search);
  if (query.get("sessionexp") === "1") {
    isSessionExp = true;
  }

  const navigate = useNavigate();

  // 入力チェック用
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  // エラーメッセージ
  const [errorMsg, setErrorMsg] = useState("");

  // スクロールを一番上に移動
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  };

  useEffect(() => {
    (function () {
      // 既にログイン済みの場合は/mypageへ
      if (isAuthenticated) navigate("/mypage", { replace: true });
      document.title = `ログイン | ${MYPAGE_HTML_TITLE}`;
      scrollTop();
    })();
  }, [isAuthenticated, navigate]);

  // ログインボタン
  const onSubmit = async (data) => {
    const result = await mypageLogin(data);
    if (!result) {
      setErrorMsg(MSG.LOGIN_FAIL);
    } else {
      const locationHref = query.get("next");
      if (locationHref !== null && locationHref.startsWith("/mypage")) {
        // 遷移先パラメータがあればそちらに遷移
        navigate(locationHref, { replace: true });
      }
    }
  };

  return (
    <>
      <ScreenColorSetting screenColor={screenColor} />
      <div className="mypage-site">
        <Header
          setScreenColor={setScreenColor}
          screenColor={screenColor}
          isLogin={false}
        />
        <main className="l-main">
          <div className="container">
            <div className="col-lg-10 offset-lg-1">
              <div className="p-login-con">
                <div className="p-login-con__top">
                  <img
                    className="p-login-con__logo"
                    src="/common/assets/images/logo01.svg"
                    alt=""
                  />
                </div>
                <h2 className="p-login-con__ttl">
                  渋谷ハチコウ大学マイページログイン
                </h2>
                <p className="p-login-con__txt">
                  このページは、渋谷ハチコウ大学の学生用ページです。
                </p>
                {isSessionExp ? (
                  <div className="p-login-con__err">
                    <p className="p-login-con__err-txt">
                      一定時間が経過したためログアウトしました。再度ログインしてください。
                    </p>
                  </div>
                ) : (
                  <></>
                )}
                {errorMsg.length > 0 ? (
                  <div className="p-login-con__err">
                    <p className="p-login-con__err-txt">{errorMsg}</p>
                  </div>
                ) : (
                  <></>
                )}
                <form
                  action=""
                  className="p-login-form"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <div className="p-login-con__form">
                    {/* 必須マークを出さないようにあえてrequired未設定 */}
                    <MypageTextField
                      name="login_id"
                      label="学生番号"
                      maxLength={8}
                      register={register}
                      validation={{
                        ...validateRequired(),
                        ...validateHalfAlphaNum(),
                      }}
                      errors={errors}
                      watch={watch}
                      placeholder="学生番号を入力してください"
                      autocomplete="off"
                    />
                    <MypageTextField
                      type="password"
                      name="password"
                      label="パスワード"
                      register={register}
                      validation={{
                        ...validateRequired(),
                        ...validateHalfAlphaNum(),
                      }}
                      errors={errors}
                      watch={watch}
                      placeholder="パスワードを入力してください"
                      autocomplete="off"
                    />
                    <div className="p-login-form__btn">
                      <button type="submit" className="p-login-form__link">
                        ログイン
                      </button>
                    </div>
                  </div>
                </form>
                <div className="p-login-con__bottom">
                  <ul className="p-login-con__list">
                    <li className="p-login-con__item">
                      <Link
                        className="p-login-con__link"
                        to="/mypage/inquiry"
                        state={{ prevlink: "/mypage/login", isMypage: true }}
                      >
                        学生番号をお忘れの方
                      </Link>
                    </li>
                    <li className="p-login-con__item">
                      <Link className="p-login-con__link" to="/mypage/password">
                        パスワードをお忘れの方
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="p-login-return">
                <a
                  className="p-login-return__link"
                  href={process.env.REACT_APP_SHIBUKATSU_WEB_DOMAIN + "/"}
                >
                  <img
                    className="p-login-return__img"
                    src="/common/assets/images/logo02.svg"
                    alt=""
                  />
                  <span className="p-login-return__txt">
                    シブカツトップページに戻る
                  </span>
                </a>
              </div>
            </div>
          </div>
        </main>
        <Footer is_login={true} />
      </div>
    </>
  );
};
export default Login;
